<template>
    <div>

        <div class="also-items">
          <div class="inner" v-if="items && items.length !== 0">
            <h2 class="also-title">Also in this festival</h2>
            <ul>
              <li v-for="item in items" :key="item.id">
                <router-link :to="item.link">
                  <figure class="image" v-if="item.featured_image">
                    <img :src="item.featured_image.medium_4x3">
                  </figure>
                  <div class="col">
                    <time v-if="item.date_str">
                      {{item.date_str}}
                    </time>
                    <h2 class="post-title" v-html="item.post_title"></h2>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="festival-btn" v-if="festival.link">
          <Button :key="festival.link" :link_url="festival.link" :color="'black'" :size="'large'">
            View all festival events
          </Button>
        </div>
    </div>

</template>

<script>
import Button from '@/components/ui/Button.vue';

export default {
    name: 'also-items',

    components: {
        Button,
    },

    props: {
        items: {
            type: Array,
            default: [],
        },
        festival: {
            type: Object,
            default: {},
        },
    },


}
</script>

<style lang="scss">
    .also-items {
        padding: var(--padding) var(--padding-x3);
        background: var(--theme-1-color-1);
        overflow: hidden;

        .also-title {
            font-size: var(--medium-size);
        }

        ul {
            display: flex;
            flex-wrap: wrap;
            padding: var(--padding-50);
            margin: 0 -2.5rem;


            li {
                width: 33.33%;
                padding: var(--padding-50);
                box-sizing: border-box;

                a {
                    display: block;
                }

                img {
                    width: 100%;
                    display: block;
                    margin: 0 0 var(--padding-25)
                }

                h2,
                time {
                    margin: .3rem 0;
                    font-size: var(--small-size);
                }
            }
        }
    }

    .post-wrap .festival-btn {
        text-align: center;
        padding: var(--padding-x2);

        .ui-button {
            margin: 0;
            border: none;
            background: var(--light-gray);

            &:hover {
                background: black;
            }
        }
    }


    @media only screen and (max-width: 767px) {
        .related-items {
            padding: var(--padding);
        }
    }
</style>
